import { OnboardingGlobalStateModel } from '../onboarding.state';

export const stateGlobalDefault: OnboardingGlobalStateModel = {
  menuOpen: false,
  hasAPIErrors: null,
  documentUploadSuccess: false,
  axaOptOutUploadSuccess: false,
  isLoggedIn: false,
  isElevated: false,
  ssoUserId: null,
};
